import React, { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { api } from "../lib/api";
import { AnnouncementBar } from "../components/site/AnnouncementBar";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { CoverageMarquee } from "../components/site/CoverageMarquee";
import { Services } from "../components/site/Services";
import { About } from "../components/site/About";
import { VideoShowcase } from "../components/site/VideoShowcase";
import { Testimonials } from "../components/site/Testimonials";
import { DriverForm } from "../components/site/DriverForm";
import { Booking } from "../components/site/Booking";
import { Contact } from "../components/site/Contact";

export default function Landing() {
  const [content, setContent] = useState(null);
  const lenisRef = useRef(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const onNav = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: id === "hero" ? 0 : -60 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  if (!content) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center">
        <div className="font-display text-taxi text-4xl animate-pulse">MY TAXI</div>
      </div>
    );
  }

  return (
    <div className="bg-taxi">
      <div className="grain" />
      <AnnouncementBar onNav={onNav} />
      <Navbar content={content} onNav={onNav} />
      <Hero content={content} onNav={onNav} />
      <CoverageMarquee content={content} />
      <Services content={content} onNav={onNav} />
      <About content={content} />
      <VideoShowcase content={content} />
      <Testimonials content={content} />
      <DriverForm />
      <Booking content={content} />
      <Contact content={content} />
    </div>
  );
}
